import { VFC } from 'react';

import { useMintAsks } from '@/apis/aniftyBackend/mintAsks/getMintAsks';
import DefaultSpinner from '@/components/DefaultSpinner';
import FailedAndRetry from '@/components/FailedAndRetry';
import styles from '@/containers/AuctionActivity/AuctionActivity.module.scss';
import AuctionActivityCard from '@/containers/AuctionActivity/AuctionActivityCard';
import NoItemsAnimon from '@/containers/UserProfilePage/NoItemsAnimon';

const MyAuctionList: VFC = () => {
  const {
    data: mintAsks,
    isLoading,
    isLoadingError,
    refetch,
    isSuccess,
  } = useMintAsks({
    // don't show cancelled asks
    ignoreCancelledAsks: true,
  });

  return (
    <div className={styles.activityContent}>
      {isLoading ? (
        <div className={styles.message}>
          <DefaultSpinner />
        </div>
      ) : null}

      {isLoadingError ? (
        <FailedAndRetry isProcessing={isLoading} onRetryButtonClick={refetch} />
      ) : null}

      {isSuccess ? (
        <>
          {mintAsks?.length ? (
            <div className={styles.listContainer}>
              {mintAsks.map((mintAsk) => (
                <AuctionActivityCard
                  key={mintAsk.askHash}
                  askHashWithCreation={mintAsk}
                />
              ))}
            </div>
          ) : (
            <NoItemsAnimon />
          )}
        </>
      ) : null}
    </div>
  );
};

export default MyAuctionList;
